.submittals-label {
  color: #00bcd4;
  font-weight: bold;
  letter-spacing: 2px;
  margin-right: 16px;
}

.submittals-banner {
  background: #b2ebf2;
  color: #006064;
  padding: 12px 20px;
  border-radius: 6px;
  margin: 16px 0 24px 0;
  font-size: 1.1em;
}

.table-container {
  height: 100%;
  overflow: auto;
  position: relative;
}

.submittal-detail-card {
  background: #e0f7fa;
  border-top: 6px solid #00bcd4;
  margin-top: 16px;
}

.approved-status {
  color: #388e3c;
  font-weight: bold;
}
.rejected-status {
  color: #d32f2f;
  font-weight: bold;
}

/* ============================== detail page layout Styles ============================== */

/**
https://ionicframework.com/docs/layout/css-utilities
utility classes that should work from Ionic but do nothing on our project
*/
.ion-display-flex {
  display: flex;
}

.full-height {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.vertical-scroll {
  overflow-y: auto;
  height: 100%;
}

.flex-grow {
  flex-grow: 1;
  overflow-y: auto;
}

@media (min-width: 576px) {
  .cc-padding-horizontal-sm-up {
    padding: 0 16px;
  }
}

.description-container {
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
}

.description {
  flex: 1;
}

.mobile-expanded-content {
  margin-top: 16px;
}

.description-container {
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
}

.description {
  flex: 1;
}

/* ============================== Timeline Styles ============================== */

.timeline-container {
  padding: 0 40px 0 40px !important;
}

.timeline-bar {
  position: relative;
  min-height: 80px;
  font-size: 0.8em;
}

.timeline-bar .bar {
  position: absolute;
  top: 17px; /* half of the height of the timeline-state img */
  width: 100%;
  height: 2px;
}

.timeline-bar .bar.complete {
  background-color: #388e3c;
}
.timeline-bar .bar.overdue {
  background-color: red;
}
.timeline-bar .bar.current {
  background-color: var(--ion-color-primary, gold);
}
.timeline-bar .bar.future {
  background-color: grey;
}

.timeline-state .circle.complete {
  border-color: #388e3c;
}
.timeline-state .circle.current {
  border-color: var(--ion-color-primary, gold);
}
.timeline-state .circle.overdue {
  border-color: red;
}
.timeline-state .circle.future {
  border-color: grey;
}

.timeline-state {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  transform: translateX(-50%);
}

.timeline-state .circle {
  width: 34px;
  height: 34px;
  border-width: 2px;
  border-style: solid;
  border-radius: 50%;
  background-size: cover;
  background-color: grey;
}

.timeline-state .circle-stack {
  position: relative;
  width: 36px;
  height: 36px;
}

/** always the top/last circle */

.timeline-state ion-icon.complete {
  position: absolute;
  top: 0;
  right: -4px;
  color: #388e3c;
  font-size: 18px;
}

.timeline-state img {
  width: 34px;
  height: 34px;
}

.timeline-state .label {
  text-align: center;
  white-space: nowrap;
}

.timeline-marker {
  position: absolute;
  top: -16px; /* need to figure this out */
  transform: translateX(-50%); /* center the marker on xpos */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}

.rounded-bg {
  background: grey;
  padding: 0px 4px;
  border-radius: 8px;
  font-size: 0.8em;
  color: black;
}

.vertical-bar {
  width: 2px;
  height: 20px;
  background: grey;
}

/* ============================== Revision Styles ============================== */

/* Revision List Styles */
.revision-list {
  height: fit-content;
  max-height: 400px;
}

.revision-list-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 300px;
  overflow-y: auto;
}

.revision-item {
  display: flex;
  flex-direction: column;
  padding: 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.revision-item:hover {
  border-color: #00bcd4;
}

.revision-item.selected {
  border-color: #00bcd4;
}

.revision-number {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 4px;
}

.revision-number__content {
  flex: 1;
}

.revision-status {
  font-size: 0.9em;
  color: #666;
  margin-bottom: 2px;
}

.revision-date {
  font-size: 0.8em;
  color: #999;
}

.accepted-answer {
  float: inline-end;
  color: var(--color-success-1, green);
}

.accepted-answer ion-icon {
  color: var(--color-success-1, green);
}

.drop-zone {
  border: 2px dashed grey;
  color: grey;
  text-align: center;
  transition: border 0.2s ease;
}

.drag-over {
  border: 2px dashed var(--ion-color-primary, #3dc2ff);
  color: var(--ion-color-primary, 'yellow');
  text-align: center;
  background-color: rgba(255, 255, 255, 0.1);
}

.submital-detail-filter-name {
  color: var(--background-color-step-400);
}

/* ============================== Submittal Edit Modal Styles ============================== */

/* the submittal-edit-modal gets rendered in the sidebar of the specification viewer
so that means the max height is less to accommodate the concourse-header above.
*/
@media (min-width: 768px) {
  .edit-modal-content {
    --background: var(--color-background-3, grey);
    max-height: calc(100vh - 57px - 57px - 57px); /* here we have 2 headers and a footer */
    overflow-y: auto;
    flex: 1; /* KEY: take remaining space */
  }
}

@media (max-width: 768px) {
  .edit-modal-content {
    --background: var(--color-background-3, grey);
    max-height: calc(100vh - 57px - 57px); /* here we have 1 header and a footer */
    overflow-y: auto;
    flex: 1; /* KEY: take remaining space */
  }
}

.edit-modal-content ion-grid ion-col {
  padding: 2px;
}




/* ============================== Submittal detail viewer layout ============================== */

.submittal-document-viewer {
  flex: 1 1 0;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
}

/* ============================== Submittal colum and tabs Modal Styles ============================== */

.panel-layout {
  height: 100%;
  display: flex;
  flex-direction: column;
  /* background-color: #21201F; */
}

.panel-col {
  height: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  flex: 0 0 400px;
  width: 400px;
  max-width: 400px;
}

@media (min-width: 768px) {
  .panel-col {
    border-top-left-radius: 20px;
    background-color: #21201F;
    overflow: hidden;
  }
}

@media (max-width: 767.98px) {
  .panel-col {
    flex: 1 1 100%;
    width: 100%;
    max-width: 100%;
  }
}

.panel-col .panel-layout {
  flex: 1;
  min-height: 0;
  width: 100%;
}

.middle-row {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  overflow: hidden;
}

.column-content {
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  min-width: 0;
  min-height: 0;
  max-width: 100%;
  height: 100%;
  overflow: hidden;
  /* background-color: #21201F; does this need to be move to a variable? */
}

.panel {
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  min-height: 0;
  height: 100%;
}

.panel-content {
  flex: 1 1 0;
  min-height: 0;
}

.panel-controls {
  flex: 0 0 auto;
  flex-shrink: 0;
  border-top: 1px solid var(--background-color-step-200, #333);
}


.column-buttons {
  flex: 0 0 56px;
  max-width: 56px;
  min-width: 56px;
  overflow: hidden;
  border-left: 1px solid var(--background-color-step-150);
}

.column-buttons ion-segment {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.column-buttons ion-segment-button {
  font-size: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  min-width: 0;
  width: 100%;
  max-width: 56px;
  --padding-start: 0;
  --padding-end: 0;
  --padding-top: 6px;
  --padding-bottom: 6px;
  --indicator-height: 0px;
  --color: #ffffff;
  --color-checked: #ffffff;
  color: #ffffff;
}

.column-buttons ion-segment-button::part(native) {
  min-width: 0;
  width: 100%;
  flex-direction: column;
  padding-inline: 2px;
}

.column-buttons ion-segment-button ion-icon {
  font-size: 18px;
  color: #ffffff;
}

.column-buttons ion-segment-button.segment-button-checked {
  background-color: #21201f;
  --color: var(--color-primary-1);
  --color-checked: var(--color-primary-1);
  color: var(--color-primary-1);
}

.column-buttons ion-segment-button.segment-button-checked::part(native) {
  background: #21201f;
}

.column-buttons ion-segment-button.segment-button-checked ion-icon {
  color: var(--color-primary-1);
}

.column-buttons ion-segment-button.segment-button-checked .submittal-tab-label {
  color: var(--color-primary-1);
}

.submittal-tab-label {
  margin-top: 2px;
  margin-bottom: 2px;
  color: #ffffff;
  text-align: center;
  line-height: 1.1;
  white-space: normal;
  word-break: break-word;
}

.submittal-tab-indicator {
  display: block;
  width: 34px;
  height: 1px;
  margin: 0 auto 4px;
  background-color: var(--color-primary-1);
  border-radius: 1px;
  flex-shrink: 0;
}

.submittal-tab-indicator--hidden {
  visibility: hidden;
}

.submittal-mobile-tabs {
  flex: 0 0 52px;
  height: 52px;
  min-height: 52px;
  max-height: 52px;
  overflow: hidden;
  border-top: 1px solid var(--background-color-step-150);
  /* background-color: #21201f; */
}

.submittal-mobile-tabs__bar {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  width: 100%;
  height: 52px;
}

.submittal-mobile-tabs__button {
  flex: 1 1 0;
  min-width: 0;
  height: 52px;
  margin: 0;
  padding: 4px 2px 6px;
  border: none;
  background: transparent;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
}

.submittal-mobile-tabs__button ion-icon {
  font-size: 18px;
  color: #ffffff;
  flex-shrink: 0;
}

.submittal-mobile-tabs__button .submittal-tab-label {
  margin: 0;
  font-size: 10px;
  line-height: 1;
  color: #ffffff;
}

.submittal-mobile-tabs__button .submittal-tab-indicator {
  width: 28px;
  height: 1px;
  margin: 0;
  flex-shrink: 0;
}

.submittal-mobile-tabs__button--selected {
  background-color: #2a2928;
  color: var(--color-primary-1);
}

.submittal-mobile-tabs__button--selected ion-icon,
.submittal-mobile-tabs__button--selected .submittal-tab-label {
  color: var(--color-primary-1);
}

.submittal-panel-card__header {
  flex: 0 0 50px;
  height: 50px;
  box-sizing: border-box;
  width: 100%;
  border-bottom: 1px solid var(--background-color-step-150);
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: flex-start !important;
  text-align: start !important;
}

.submittal-panel-card__header ion-card-title {
  margin: 0;
  text-align: start !important;
}

.submittal-details-card,
.submittal-comments-card {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.submittal-details-card__body,
.submittal-comments-card__body {
  flex: 1 1 0;
  min-height: 0;
  overflow-y: auto;
}

.submittal-preview-card__header {
  justify-content: space-between !important;
  padding-inline-end: 4px;
}

.submittal-preview-card__add-button {
  --color: var(--color-primary-1);
  --padding-start: 4px;
  --padding-end: 8px;
  margin: 0;
  height: auto;
  min-height: unset;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.submittal-preview-card__add-button ion-icon {
  color: var(--color-primary-1);
  font-size: 16px;
}

.submittal-preview-card__uploads {
  flex: 0 0 auto;
  border-bottom: 1px solid var(--background-color-step-150);
}

.submittal-preview-card {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.submittal-preview-card__thumbs {
  flex: 1 1 0;
  min-height: 0;
  overflow-y: auto;
  width: 100%;
}

.submittal-preview-card__body {
  flex: 1 1 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.submittal-preview-card__loading {
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  color: var(--ion-color-medium);
  min-height: 0;
}

.submittal-preview-card__loading--inline {
  flex: 0 0 auto;
  padding: 1rem;
}

.submittal-files-card {
  height: 100%;
  min-height: 0;
  min-width: 0;
  box-sizing: border-box;
}


.thumb--selected img,
.thumb--selected .thumb__placeholder-label,
.thumb--selected .thumb__svg {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
}

.thumb__svg {
  overflow: hidden;
  background: #fff;
}

.thumb__svg svg {
  display: block;
  width: 100%;
  height: 100%;
}

.thumb__placeholder-label {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 180px;
  height: 233px;
  background: var(--color-grey-4, #666);
  color: #fff;
  font-size: 14px;
  text-align: center;
  padding: 8px;
  box-sizing: border-box;
}
